// 【已停用】钉钉登录：dingtalkLogin 不再引入
import { getFails, login } from '@/api/login'

export default {
    components: {
    },
    data () {
        return {
            platform: this.$route.params.platform,
            token: this.$route.query.token,
            model: {},
            loading: false,
            showDingtalkLogin: false, // 控制钉钉登录状态显示
            selectedAccountId: null,
            dingtalkLoginData: null, // 存储第一次登录返回的凭证

            // 钉钉登录状态
            dingtalkLoginLoading: false,
            dingtalkLoginStatus: 'ready', // ready, loading, processing, error
            dingtalkLoginError: '',

            rules: {
                username: [ { required: true, message: '请输入账号', trigger: 'change' }],
                password: [ { required: true, message: '请输入密码', trigger: 'change' }],
            }
        }
    },
    computed: {
        locked() {
            return this.$store.state.stores.fails >= 100
        }
    },
    mounted () {
        getFails().then(res => {
            this.$store.commit('setFails', res.data.fails)
        })

        if (this.token) {
            localStorage.setItem('token', this.token)
        }

        if (!['sys', 'dstr', 'chan', 'stf'].includes(this.platform)) {
            this.platform = 'sys'
        }

        const token = this.token || localStorage.getItem('token')
        const platform = localStorage.getItem('platform')
        localStorage.setItem('platform', this.platform)

        if (platform !== this.platform) {
            localStorage.removeItem('token')
            location.reload()
            return
        }

        token && this.$router.push({ name: 'home' })
        this.$store.commit('setAdmin', null)

        // 【已停用】钉钉登录：不再处理钉钉回调
        // this.checkDingtalkCallback()
    },
    methods: {
        login() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.doLogin()
            });
        },
        doLogin() {
            this.loading = true
            login(this.model).then(() => {
                this.$message.destroy()
                this.$message.success('登录成功')
                this.$router.push({ name: 'home' })
                this.loading = false
            }).catch(response => {
                const data = response.data.data
                if (data && typeof data.fails !== 'undefined') {
                    this.$store.commit('setFails', data.fails)
                }
                this.loading = false
            })
        },

        /* ===== 【已停用】钉钉登录相关方法（保留以便后续恢复）=====
        // 钉钉登录点击处理
        handleDingtalkLoginClick(type = 'zhumengren') {
            this.dingtalkLoginLoading = true
            
            // 生成钉钉授权URL
            const authUrl = this.generateDingtalkAuthUrl(type)
            
            console.log('跳转到钉钉授权页面:', authUrl)
            
            // 跳转到钉钉授权页面
            window.location.href = authUrl
            
            // 显示登录状态（用户会离开页面，这个主要是为了回调后的状态）
            this.showDingtalkLogin = true
            this.dingtalkLoginStatus = 'loading'
        },

        // 生成钉钉授权URL
        generateDingtalkAuthUrl(type) {
            // const env = 'development' // 根据实际情况调整
            const env = 'production' // 根据实际情况调整
            const clientId = env === 'production' ? (type === 'zhumengren' ? 'dingw2prs0b6ldh3hf4v' : 'dingu8om36md7nwjexlz') : 'dinggbeld8mhb4wpsbpx'
            const redirectUri = env === 'production'
                ? `${location.origin}/login`
                : `http://localhost:8080/login`
            
            // 构建钉钉OAuth2授权URL
            const params = {
                client_id: clientId,
                redirect_uri: encodeURIComponent(redirectUri),
                response_type: 'code',
                scope: 'openid',
                state: this.generateState() + '_' + type,
                prompt: 'consent'
            }
            
            const queryString = Object.entries(params)
                .map(([key, value]) => `${key}=${value}`)
                .join('&')
            
            return `https://login.dingtalk.com/oauth2/auth?${queryString}`
        },

        // 生成随机state参数
        generateState() {
            return Math.random().toString(36).substring(2) + Date.now().toString(36)
        },

        parseOrgKeyFromState(state) {
            if (!state) return null
            const lastUnderscore = state.lastIndexOf('_')
            if (lastUnderscore === -1) return null
            return state.substring(lastUnderscore + 1)
        },

        checkDingtalkCallback() {
            const authCode = this.$route.query.authCode || this.$route.query.code
            const state = this.$route.query.state
            if (authCode) {
                console.log('检测到钉钉回调 authCode:', authCode)

                const orgKey = this.parseOrgKeyFromState(state)
                console.log('从 state 中解析 org_key:', orgKey)

                const cleanUrl = window.location.pathname
                window.history.replaceState({}, document.title, cleanUrl)

                this.autoHandleDingtalkCallback(authCode, orgKey)
            }
        },

        // 自动处理钉钉回调
        async autoHandleDingtalkCallback(authCode, orgKey) {
            this.showDingtalkLogin = true
            this.dingtalkLoginStatus = 'processing'
            
            try {
                // 调用钉钉登录接口
                const response = await dingtalkLogin({
                    authCode: authCode,
                    org_key: orgKey,
                })
                
                const data = response.data
                
                // 情况1：直接返回 token，登录成功
                if (data.token) {
                    // 存储token
                    localStorage.setItem('token', data.token)
                    
                    // 存储钉钉用户信息
                    if (data.dingtalk_user) {
                        localStorage.setItem('dingtalk_user', JSON.stringify(data.dingtalk_user))
                    }
                    
                    this.$message.success('登录成功')
                    this.$router.push({ name: 'home' })
                    return true
                } 
                // 情况2：返回多个账号列表，需要选择
                else if (data.list && data.list.length > 0) {
                    console.log('检测到多个账号，显示选择弹窗');
                    
                    // 保存登录凭证，用于第二次调用
                    this.dingtalkLoginData = {
                        dingtalk_login_token: data.dingtalk_login_token,
                        authCode: authCode
                    };
                    
                    // 显示账号选择弹窗
                    this.showAccountSelection(data.list);
                    return false;
                }
                // 情况3：其他错误
                else {
                    // ⭐ 直接返回到登录页
                    this.resetToLoginPage(data.message || '登录失败');
                    this.dingtalkLoginStatus = 'error'
                    this.dingtalkLoginError = data.message || '登录失败'
                    return false
                }
            } catch (error) {
                const errorMsg = error.response?.data?.message || '登录失败'
                this.dingtalkLoginStatus = 'error'
                this.dingtalkLoginError = errorMsg
                // ⭐ 直接返回到登录页
                this.resetToLoginPage(errorMsg);
                return false
            } finally {
                this.dingtalkLoginLoading = false
            }
        },

        // 重试钉钉登录
        retryDingtalkLogin() {
            this.showDingtalkLogin = false
            this.dingtalkLoginStatus = 'ready'
            this.dingtalkLoginError = ''
        },

        // 处理钉钉登录
        async handleDingtalkLogin(loginData) {
            try {
                const response = await dingtalkLogin({
                    authCode: loginData.authCode,
                    org_key: loginData.org_key,
                })
                
                const data = response.data
                
                // 情况1：直接返回 token，登录成功
                if (data.token) {
                    // 存储token
                    localStorage.setItem('token', data.token)
                    
                    // 存储钉钉用户信息
                    if (data.dingtalk_user) {
                        localStorage.setItem('dingtalk_user', JSON.stringify(data.dingtalk_user))
                    }
                    
                    this.$message.success('登录成功')
                    this.$router.push({ name: 'home' })
                    return true
                } 
                // 情况2：返回多个账号列表，需要选择
                else if (data.list && data.list.length > 0) {
                    console.log('检测到多个账号，显示选择弹窗');
                    
                    // 保存登录凭证，用于第二次调用
                    this.dingtalkLoginData = {
                        dingtalk_login_token: data.dingtalk_login_token,
                        authCode: loginData.authCode
                    };
                    
                    // 显示账号选择弹窗
                    this.showAccountSelection(data.list);
                    return false;
                }
                // 情况3：其他错误
                else {
                    this.$message.error(data.message || '登录失败2')
                    // ⭐ 关键：通知子组件登录失败
                    if (this.$refs.dingtalkLogin && this.$refs.dingtalkLogin.handleLoginFailed) {
                        this.$refs.dingtalkLogin.handleLoginFailed(data.message || '登录失败')
                    }
                    return false
                }
            } catch (error) {
                const errorMsg = error.response?.data?.message || '登录失败'
                this.$message.error(errorMsg)
                
                // ⭐ 关键：通知子组件登录失败
                if (this.$refs.dingtalkLogin && this.$refs.dingtalkLogin.handleLoginFailed) {
                this.$refs.dingtalkLogin.handleLoginFailed(errorMsg)
                }
                return false
            }
        },
        // 显示账号选择弹窗
        showAccountSelection(accountList) {
            console.log('显示选择弹窗，账号列表:', accountList);
            
            if (!accountList || accountList.length === 0) {
                this.$message.error('账号列表为空');
                return;
            }
            
            // 设置默认选择第一个账号
            this.selectedAccountId = accountList[0].dingtalk_id;
            
            // 使用 Vue 的 createElement 函数
            const content = (h) => h('div', [
                h('p', '您的钉钉账号绑定了多个后台账号，请选择要登录的账号：'),
                h('a-radio-group', {
                    props: {
                        value: this.selectedAccountId
                    },
                    style: { width: '100%' },
                    on: {
                        change: (e) => {
                            console.log('用户选择账号ID:', e.target.value);
                            this.selectedAccountId = e.target.value;
                        }
                    }
                }, accountList.map(account => 
                    h('a-radio', {
                        key: account.dingtalk_id,
                        props: {
                            value: account.dingtalk_id
                        },
                        style: {
                            display: 'block',
                            marginBottom: '10px',
                            padding: '10px',
                            border: '1px solid #e8e8e8',
                            borderRadius: '4px',
                            backgroundColor: this.selectedAccountId === account.dingtalk_id ? '#f0f9ff' : '#fff'
                        }
                    }, [
                        h('div', { style: { display: 'flex', alignItems: 'center' } }, [
                            h('div', [
                                h('strong', account.name),
                                h('div', { 
                                    style: { 
                                        fontSize: '12px', 
                                        color: '#999', 
                                        marginTop: '4px' 
                                    }
                                }, `账号: ${account.username} | 钉钉昵称: ${account.nick}`)
                            ])
                        ])
                    ])
                ))
            ]);
            
            // 使用 Ant Design 的 Modal 组件
            this.$confirm({
                title: '选择登录账号',
                content: content,
                okText: '确认登录',
                cancelText: '取消',
                width: 400,
                onOk: () => {
                    console.log('确认登录，选择账号ID:', this.selectedAccountId);
                    return this.confirmAccountSelection();
                },
                onCancel: () => {
                    console.log('用户取消选择');
                    // ⭐ 直接返回到登录页
                    this.resetToLoginPage('您已取消账号选择');
                }
            });
        },
        // 确认选择的账号并登录
        async confirmAccountSelection() {
            if (!this.selectedAccountId) {
                this.$message.warning('请选择一个账号');
                return;
            }

            if (!this.dingtalkLoginData || !this.dingtalkLoginData.dingtalk_login_token) {
                this.$message.error('登录凭证失效，请重新扫码');
                // ⭐ 直接返回到登录页
                this.resetToLoginPage('登录凭证失效');
                return;
            }

            console.log('确认登录，参数:', {
                dingtalk_id: this.selectedAccountId,
                dingtalk_login_token: this.dingtalkLoginData.dingtalk_login_token
            });
            
            try {
                // 第二次调用：传递 dingtalk_id 和 dingtalk_login_token
                const response = await dingtalkLogin({
                    dingtalk_id: this.selectedAccountId,
                    dingtalk_login_token: this.dingtalkLoginData.dingtalk_login_token
                });
                
                console.log('第二次调用响应:', response.data);
                const data = response.data;
                
                if (data.token) {
                    // 存储token
                    localStorage.setItem('token', data.token);
                    
                    // 存储钉钉用户信息
                    if (data.dingtalk_user) {
                        localStorage.setItem('dingtalk_user', JSON.stringify(data.dingtalk_user));
                    }
                    
                    this.$message.success('登录成功');
                    this.$router.push({ name: 'home' });
                    return true;
                } else {
                    // ⭐ 登录失败后直接返回到登录页
                    this.resetToLoginPage(data.message || '登录失败');

                    // 登录失败后可以重新显示弹窗
                    if (data.list && data.list.length > 0) {
                        this.dingtalkLoginData.dingtalk_login_token = data.dingtalk_login_token;
                        this.showAccountSelection(data.list);
                    }
                    return false;
                }
            } catch (error) {
                const errorMsg = error.response?.data?.message || '登录失败';
                // ⭐ 直接返回到登录页
                this.resetToLoginPage(errorMsg);
                return false;
            }
        },
        // 返回账号密码登录
        backToPasswordLogin() {
            this.showDingtalkLogin = false
            this.selectedAccountId = null;
            this.dingtalkLoginData = null;
            this.dingtalkLoginStatus = 'ready'
            this.dingtalkLoginError = ''
        },
        // 重置到登录页
        resetToLoginPage(message = '') {
            // 重置所有状态
            this.showDingtalkLogin = false;
            this.selectedAccountId = null;
            this.dingtalkLoginData = null;
            this.dingtalkLoginStatus = 'ready';
            this.dingtalkLoginError = message;
            
            // 如果有错误消息，显示提示
            if (message) {
                // 可以在这里显示错误提示，比如使用全局通知
                this.$message.warning(message);
            }
            
            console.log('已重置到登录页，状态:', {
                showDingtalkLogin: this.showDingtalkLogin,
                dingtalkLoginStatus: this.dingtalkLoginStatus
            });
        },
        ===== 【已停用】钉钉登录相关方法结束 ===== */
    },
    filters: {
        platformName(type) {
            let name = null
            switch (type) {
                default:
                    name = ''
            }
            return name
        }
    }
}
